import { render, staticRenderFns } from "./ActiveRequests.vue?vue&type=template&id=85ca4ae8"
import script from "./ActiveRequests.vue?vue&type=script&lang=js"
export * from "./ActiveRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports